import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { useRecoilValue } from 'recoil';
import { projectConfigState } from 'recoil/Academy/projectConfigState';
import ShareButtonKakao from 'app.feature/academy/cbt.detail/component/ShareButtonKakao';
import useToastMessage from '../../../../app.component/LEGACY__atoms/Common/Toast/hooks/useToastMessage';
import { hostState } from '../../../../../recoil/Academy/hostState';

const ShareItems = ({ examInfo, description }: any) => {
  const { openToastMessage } = useToastMessage();
  const { clientBaseUrl, projectNameKR, logoImagePng, kakaoServiceKey } =
    useRecoilValue(projectConfigState);
  const label = `${examInfo?.examName} | 시험 CBT - ${projectNameKR}`;
  const host = useRecoilValue(hostState);
  const shareLink = `https://${host}/exam/detail/${examInfo?.examIdx}`;

  const shareLinks = [
    {
      href: `https://www.facebook.com/sharer/sharer.php?u=${clientBaseUrl}`,
      className: 'facebook',
      ariaLabel: 'Facebook으로 공유하기',
    },
    {
      href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        label
      )}&hashtags=CBT&url=${encodeURIComponent(clientBaseUrl)}`,
      className: 'x',
      ariaLabel: 'X로 공유하기',
    },
    {
      href: `https://share.naver.com/web/shareView?url=${encodeURIComponent(
        clientBaseUrl
      )}&title=${encodeURIComponent(label)}`,
      className: 'naver',
      ariaLabel: 'Naver로 공유하기',
    },
    {
      href: `https://band.us/plugin/share?body=${encodeURIComponent(`${label}\n${clientBaseUrl}`)}`,
      className: 'band',
      ariaLabel: 'Band로 공유하기',
    },
  ];

  const copyToClipBoard = async () => {
    if (!shareLink) {
      openToastMessage('링크가 존재하지 않습니다.', 'error');
      return;
    }
    try {
      await navigator.clipboard.writeText(shareLink);
      openToastMessage('링크가 복사되었습니다.', 'success');
    } catch (e) {
      openToastMessage('복사에 실패하였습니다', 'error');
    }
  };

  return (
    <StyledWrapper>
      <Grid container spacing={1}>
        <Grid item>공유하기</Grid>
        {shareLinks.map((link) => (
          <Grid item key={link.className}>
            <StyledLink
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className={link.className}
              aria-label={link.ariaLabel}
            />
          </Grid>
        ))}
        <Grid item>
          <ShareButtonKakao
            examInfo={examInfo}
            label={label}
            logoImagePng={logoImagePng}
            kakaoServiceKey={kakaoServiceKey}
          />
        </Grid>
        <Grid item key="link">
          <StyledLink
            onClick={copyToClipBoard}
            target="_blank"
            rel="noopener noreferrer"
            className="link"
            aria-label="링크 공유하기"
          />
        </Grid>
      </Grid>
    </StyledWrapper>
  );
};

export default ShareItems;

const StyledWrapper = styled.div`
  font-size: 16px;
  color: #666;
`;

const StyledLink = styled.a`
  display: inline-block;
  width: 30px;
  height: 30px;
  background-size: cover;
  cursor: pointer;

  &.facebook {
    background-image: url('/icons/share-facebook-new.png');
  }
  &.x {
    border-radius: 5px;
    background-color: #000;
    background-image: url('/icons/share-x-logo.webp');
    background-size: 18px 18px;
    background-position: center;
    background-repeat: no-repeat;
  }
  &.naver {
    background-image: url('/icons/share-naver-new.png');
  }
  &.band {
    background-image: url('/icons/share-band-new.png');
  }
  &.link {
    background-color: #ccc;
    background-image: url('/icons/share-link-new.png');
    border-radius: 3px;
  }
`;
